/* ============================================================
   WITH MUSH™ — Landing Page JavaScript
   lp-landing.js
   Handles: ticker animation, FAQ accordion, image gallery tabs
   ============================================================ */

(function () {
  'use strict';

  /* Mark <html> immediately so reveal CSS only applies when JS is running.
     This prevents elements being hidden if the script is blocked or slow. */
  document.documentElement.classList.add('lp-js-ready');

  /* ============================================================
     1. TRUST TICKER (infinite scroll clone)
     ============================================================ */
  function initTicker() {
    const tracks = document.querySelectorAll('.lp-ticker__track');
    tracks.forEach(function (track) {
      // Clone the items to create seamless loop
      const items = track.querySelectorAll('.lp-ticker__item');
      if (!items.length) return;
      items.forEach(function (item) {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    });
  }

  /* ============================================================
     2. FAQ ACCORDION
     ============================================================ */
  function initFAQ() {
    const items = document.querySelectorAll('.lp-faq__item');
    items.forEach(function (item) {
      const btn = item.querySelector('.lp-faq__question');
      const answer = item.querySelector('.lp-faq__answer');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        // Close all
        items.forEach(function (i) {
          i.classList.remove('is-open');
          const a = i.querySelector('.lp-faq__answer');
          if (a) a.style.maxHeight = null;
          const q = i.querySelector('.lp-faq__question');
          if (q) q.setAttribute('aria-expanded', 'false');
        });

        // Open clicked (if was closed)
        if (!isOpen) {
          item.classList.add('is-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ============================================================
     3. STATS TAB SWITCHER (30 Days / 60 Days)
     ============================================================ */
  function initStatsTabs() {
    const containers = document.querySelectorAll('.lp-stats__tabs');
    containers.forEach(function (tabs) {
      const buttons = tabs.querySelectorAll('.lp-stats__tab');
      const section = tabs.closest('.lp-stats');
      if (!section) return;

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          const target = btn.dataset.tab;
          const panels = section.querySelectorAll('.lp-stats__panel');
          panels.forEach(function (panel) {
            panel.classList.toggle('is-active', panel.dataset.panel === target);
          });
        });
      });
    });
  }

  /* ============================================================
     4. BENEFITS CAROUSEL (mobile swipe)
     ============================================================ */
  function initBenefitsCarousel() {
    const carousels = document.querySelectorAll('.lp-benefits__carousel');
    carousels.forEach(function (carousel) {
      let startX = 0;
      let isDragging = false;

      carousel.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        isDragging = true;
      }, { passive: true });

      carousel.addEventListener('touchend', function (e) {
        if (!isDragging) return;
        isDragging = false;
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          // Could trigger slide nav here if needed
        }
      });
    });
  }

  /* ============================================================
     5. ANNOUNCEMENT BAR CLOSE
     ============================================================ */
  function initAnnouncementClose() {
    const bars = document.querySelectorAll('.lp-announcement');
    bars.forEach(function (bar) {
      const closeBtn = bar.querySelector('.lp-announcement__close');
      if (!closeBtn) return;
      closeBtn.addEventListener('click', function () {
        bar.style.maxHeight = bar.scrollHeight + 'px';
        requestAnimationFrame(function () {
          bar.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
          bar.style.maxHeight = '0';
          bar.style.opacity = '0';
        });
        try {
          sessionStorage.setItem('lp-ann-closed', '1');
        } catch (e) { /* silent */ }
      });

      // Restore closed state
      try {
        if (sessionStorage.getItem('lp-ann-closed') === '1') {
          bar.style.display = 'none';
        }
      } catch (e) { /* silent */ }
    });
  }

  /* ============================================================
     6. SMOOTH SCROLL for CTA anchors
     ============================================================ */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        const target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ============================================================
     7. REVIEWS TABS FILTER
     ============================================================ */
  function initReviewsTabs() {
    const sections = document.querySelectorAll('.lp-reviews-full');
    sections.forEach(function (section) {
      const tabs = section.querySelectorAll('.lp-reviews-full__tab');
      const cards = section.querySelectorAll('.lp-reviews-full__card');
      if (!tabs.length || !cards.length) return;

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          // Update active tab
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          var target = tab.dataset.tab;

          // Show/hide cards
          cards.forEach(function (card) {
            var cardTab = card.dataset.reviewTab || 'all';
            var show = target === 'all' || cardTab === target;
            card.style.display = show ? '' : 'none';
          });
        });
      });
    });
  }

  /* ============================================================
     8. SCROLL REVEAL (lightweight intersection observer)
     ============================================================ */
  function initScrollReveal() {
    if (!window.IntersectionObserver) return;

    const elements = document.querySelectorAll('[data-lp-reveal]');
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lp-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    initAnnouncementClose();
    initTicker();
    initFAQ();
    initStatsTabs();
    initReviewsTabs();
    initBenefitsCarousel();
    initSmoothScroll();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
